<app-card-form
  [cardTitle]="'updateProfileModal.modalTitle' | translate"
  [mode]="mode"
  [displayMode]="'modal'"
  [useSmallButtons]="false"
  [isSaving]="isSaving"
  [addCancelOnShowMode]="true"
  (toggleEditMode)="onSubmit()"
  (dismissModal)="activeModal.dismiss()"
  (editItem)="onSubmit()"
  (cancelEdit)="onCancelEdit()"
>
  <form [formGroup]="profileForm">
    <div class="row mb-3">
      <div class="col-md-6">
        <label for="firstName">{{
          "updateProfileModal.firstName" | translate
        }}</label>
        <input
          type="text"
          formControlName="firstName"
          class="form-control"
          id="firstName"
        />
      </div>
      <div class="col-md-6">
        <label for="lastName">{{
          "updateProfileModal.lastName" | translate
        }}</label>
        <input
          type="text"
          formControlName="lastName"
          class="form-control"
          id="lastName"
        />
      </div>
    </div>
    <div class="mb-3">
      <label class="form-label">{{
        "updateProfileModal.email" | translate
      }}</label>
      <input type="email" class="form-control" formControlName="email" />
    </div>
    <div class="mb-3">
      <label class="form-label">{{
        "updateProfileModal.phone" | translate
      }}</label>
      <input type="text" class="form-control" formControlName="phone" />
      <div
        *ngIf="submitted && profileForm.controls.phone.invalid"
        class="text-danger"
      >
        {{ "updateProfileModal.phoneInvalid" | translate }}
      </div>
    </div>
    <div class="mb-3">
      <label class="form-label">{{
        "updateProfileModal.password" | translate
      }}</label>
      <input
        type="password"
        class="form-control"
        formControlName="plainPassword"
      />
      <div
        *ngIf="submitted && profileForm.controls.plainPassword.invalid"
        class="text-danger"
      >
        {{ "updateProfileModal.passwordInvalid" | translate }}
      </div>
    </div>
    <div class="mb-3" *ngIf="profileForm.get('plainPassword')?.value">
      <label class="form-label">{{
        "updateProfileModal.oldPassword" | translate
      }}</label>
      <input
        type="password"
        class="form-control"
        formControlName="oldPassword"
      />
      <div
        *ngIf="submitted && profileForm.controls.oldPassword.invalid"
        class="text-danger"
      >
        {{ "updateProfileModal.oldPasswordRequired" | translate }}
      </div>
    </div>
  </form>
</app-card-form>
